<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <div class="item-wp">
          <div class="item-son" v-if="addShow">
            <el-button size="mini" type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div style="overflow: hidden" class="style_info_tab_case">
      <div class="list-style" v-for="item in tableData" :key="item.examStyleId">
        <el-image
            style="width: 250px; height: 160px"
            :src="item.icon"
            fit="none"
        ></el-image>
        <div class="cover-conter">
          <div class="flex-box flex-center-items">
            <div>{{ item.name }}</div>
            <div>
              <el-switch
                  :disabled="statusShow"
                  v-model="item.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeSwitch(item)"
              >
              </el-switch>
            </div>
          </div>
          <div class="style-elemx" style="width:100%; white-space: nowrap; text-overflow:ellipsis; overflow:hidden; ">
            {{ item.descr }}
          </div>

          <div class="time ">
            <div>{{ item.utime }}</div>
            <div style="width: 100%; margin-top:20px">
              <el-button
                  size="mini"
                  @click="handleClick('edit', item)"
                  type="success"
                  plain
                  v-if="editShow"
              >编辑
              </el-button
              >
              <el-button
                  size="mini"
                  @click="handleDelete(item)"
                  type="danger"
                  plain
                  v-if="deleteShow"
              >删除
              </el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        title="新增样式"
        :visible.sync="dialogVisible"
        width="460px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="缩略图" prop="logo">
            <div class="diplay">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListLang"
                    :key="index"
                    class="slideshow"
                    @click="getPolicyLang"
                >
                  <el-image
                      style="width: 150px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"

                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 150px; height: 75px; line-height: 80px"
                    @click="getPolicyLang"
                    v-if="isMoerLang"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="fileLang"
                  @change="getFileLang"
                  accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>

          <el-form-item label="名称" prop="name">
            <el-input
                type="text"
                placeholder="请填写详情"
                v-model="params.name"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="路径" prop="path">
            <el-input
                type="text"
                placeholder="请填写样式引用路径地址"
                v-model="params.path"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="说明">
            <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请填写说明"
                v-model="params.descr"
            >
            </el-input>
          </el-form-item>

          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="文字颜色">
                <el-color-picker v-model="wzcolor" show-alpha></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="边框颜色">
                <el-color-picker v-model="bkbg" show-alpha></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="时间背景">
                <el-color-picker v-model="sjbg" show-alpha></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="侧栏颜色">
                <el-color-picker v-model="clbg" show-alpha></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="序号" prop="seq">
            <el-input type="text" placeholder="请填写序号" v-model="params.seq">
            </el-input>
          </el-form-item>

          <el-form-item label="状态">
            <el-switch
                v-model="params.status"
                :active-value="1"
                :inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {ossUpload} from "@utils/filters/upload";

export default {
  data() {
    return {
      url: require("@assets/images/logo.jpg"),
      status: 1,
      listParams: {
        styleType: "cpdt",
      },
      params: {
        styleType: "cpdt",
        status: 1,
      },
      tableData: [],
      dialogVisible: false,
      loading: false,
      clickType: "",

      srcListLang: [],
      isMoerLang: true,
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "change"}],
        path: [
          {
            required: true,
            message: "请填写样式引用路径地址",
            trigger: "change",
          },
        ],
        seq: [{
          required: true,
          message: "请填写序号", trigger: "change"
        }],
      },

      sjbg: '',
      wzcolor: '',
      bkbg: '',
      clbg: '',

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  created() {
    this.queryStyleData();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcListLang = []
        this.isMoerLang = true
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'exam:answer:style:query') {
            this.searchShow = true
          }
          if (item.code == 'exam:answer:style:add') {
            this.addShow = true
          }
          if (item.code == "exam:answer:style:delete") {
            this.deleteShow = true
          }
          if (item.code == "exam:answer:style:edit") {
            this.editShow = true
          }
          if (item.code == "exam:answer:style:status") {
            this.statusShow = false
          }
        })
      }
    },

    async queryStyleData() {
      this.loading = true;

      const {data: resData} = await this.$get("/exam/style/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data
      // this.tableData = resData.data.sort(function (a, b) {
      //   return b.seq - a.seq;
      // });
    },
    // handleClick(type) {
    //   this.clickType = type;
    //   this.dialogVisible = true;
    // },

    getPolicyLang() {
      this.$refs.fileLang.dispatchEvent(new MouseEvent("click"));
    },
    async getFileLang() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileLang.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListLang
      );
      this.isMoerLang = false;
      this.srcListLang = addRoutes;
      this.params.icon = this.srcListLang[0];
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "edit") {
        //编辑
        this.dialogVisible = true;
        const {data: resData} = await this.$get(
            `/exam/style/info/${row.examStyleId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;
        if (resData.data) {
          this.isMoerLang = false;
          this.srcListLang = [];
          this.srcListLang.push(resData.data.icon);
          this.params = resData.data;
          if (resData.data.pageConfig) {
            if(resData.data.pageConfig.sjbg){
              this.sjbg = resData.data.pageConfig.sjbg
            }
            if(resData.data.pageConfig.wzcolor){
              this.wzcolor = resData.data.pageConfig.wzcolor
            }
            if(resData.data.pageConfig.bkbg){
              this.bkbg = resData.data.pageConfig.bkbg
            }
            if(resData.data.pageConfig.clbg){
              this.clbg = resData.data.pageConfig.clbg
            }
          }
        } else {
          this.isMoerLang = false;
          this.srcListLang = [];
          this.params = {}
          this.sjbg = ''
          this.wzcolor = ''
          this.bkbg = ''
          this.clbg = ''
        }

      }
      if (type == "add") {
        this.dialogVisible = true;
        this.params = {};
        this.sjbg = ''
        this.wzcolor = ''
        this.bkbg = ''
        this.clbg = ''
      }
    },
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        let obj = {
          sjbg: this.sjbg,
          wzcolor: this.wzcolor,
          bkbg: this.bkbg,
          clbg: this.clbg,
        }
        this.params.pageConfig = JSON.stringify(obj)
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            this.params.styleType = "cpdt ";
            const {data: resData} = await this.$post(
                "/exam/style/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;

            this.queryStyleData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const {data: resData} = await this.$put(
                "/exam/style/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;

            this.queryStyleData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
            this.params = {};
          }
        });
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/exam/style/info/${row.examStyleId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.queryStyleData();

        this.$message.success("删除成功!");
      });
    },

    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `/exam/style/info/status/${b.examStyleId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list-style {
  background: #fff;
  width: 250px;
  padding-bottom: 10px;
  margin: 0 20px 20px 0;
  float: left;
}

.cover-conter {
  margin: 10px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.flex-center-items {
  justify-content: space-between;
  align-items: center;
}

.style-elemx {
  font-size: 14px;
  margin-top: 15px;
}

.time {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}

.style_info_tab_case {
  display: flex;
  flex-wrap: wrap;
}
</style> 